<style scoped>
	#app {
		padding: 10px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 20px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<style>
	.text-center .el-input__inner {
		text-align: center;   /* 使 placeholder 和输入内容居中 */
	}
</style>
<template>
	<div id="app">
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
				<div>排序：</div>
				<el-select size="mini" v-model="search.sorts" placeholder="默认排序" style="width: 120px;">
					<el-option label="默认排序" :value="0"></el-option>
					<el-option label="连红排序" :value="1"></el-option>
					<el-option label="发单时间" :value="2"></el-option>
					<el-option label="命中率排序" :value="3"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="账号 / 昵称 / UID" v-model="search.keyword" style="margin-right: 10px; width:280px;"></el-input>
				<el-button type="primary" size="mini" @click="getData()">搜索</el-button>
				<el-button type="success" size="mini" @click="addUser()">创建大神</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="UID" label="UID" align="center" width="100">
					<template slot-scope="scope">
						{{scope.row.uid}}
					</template>
				</el-table-column>
				<el-table-column prop="sid" label="店铺" align="center" width="180">
					<template slot-scope="scope">
						{{scope.row.shop_name}}<span style="color: #999999;">({{scope.row.sid}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="会员昵称" align="center" width="140">
				</el-table-column>
				<el-table-column prop="username" label="会员账号" align="center" width="140">
				</el-table-column>
				<el-table-column prop="total_count" label="发单数" align="center" width="80">
				</el-table-column>
				<el-table-column prop="total_down" label="7日命中" align="center" width="100">
					<template slot-scope="scope">
						{{scope.row.week_red}} / {{scope.row.week_count}}
					</template>
				</el-table-column>
				<el-table-column prop="current_red" label="当前连红" align="center" width="100">
				</el-table-column>
				<el-table-column prop="total_people" label="带红人数" align="center" width="100">
				</el-table-column>
				<el-table-column prop="total_fee" label="跟单佣金" align="center" width="140">
				</el-table-column>
				<el-table-column prop="lastTime" label="最后发单时间" align="center" width="200">
				</el-table-column>
				<el-table-column prop="vFans" label="虚拟粉丝" align="center" width="160">
					<template slot-scope="scope">
						<el-input class='text-center' v-model="scope.row.vFans" @blur="fansChange(scope)"></el-input>
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" width="250" align="center">
					<template slot-scope="scope">
						<el-tag class='tag-btn' style="margin-right: 10px; cursor: pointer;" size="mini"  @click="viewOrder(scope)">历史发单</el-tag>
						<el-tag class='tag-btn' type="success" style="margin-right: 10px; cursor: pointer;" size="mini"  @click="resetPassword(scope)">重置密码</el-tag>
						<el-tag class='tag-btn' type="danger" style="margin-right: 10px; cursor: pointer;" size="mini"  @click="addPlan(scope)">立即发单</el-tag>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[14, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog :visible.sync="addUserShow" v-if="addUserShow" top="30px" width="1400px" :before-close="handleClose">
			<addUser></addUser>
		</el-dialog>
		
		<el-dialog :visible.sync="fadanShow" v-if="fadanShow" top="30px" width="1400px" :before-close="handleClose">
			<addFadan :uid="uid"></addFadan>
		</el-dialog>
		
		<el-dialog :visible.sync="detailShow" v-if="detailShow" top="30px" width="1400px" :before-close="handleClose">
			<orderList :uid="uid"></orderList>
		</el-dialog>
	</div> 
</template>

<script>
	import addUser from './addUser.vue';
	import addFadan from './addFadan.vue';
	import orderList from './orderList.vue';
	export default {
		components:{
			addUser, addFadan, orderList
		},
		computed:{
		},
		data(){
			return {
				uid:0,
				fadanShow:false,
				addUserShow:false, 
				search:{
					sorts:0,
					keyword:'',
					status:-1,
					gameType:'',
				},
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:14,
				detailShow:false,
			}
		},
		created() {
			this.getData();
		},
		methods:{
			viewOrder(scope){
				this.uid = scope.row.uid;
				this.detailShow = true;
			},
			addPlan(scope){
				this.uid = scope.row.uid;
				this.fadanShow = true;
			},
			resetPassword(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/virtuals/resetPassword", {uid:scope.row.uid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.$alert('新密码为：' + res.data.password, '密码重置成功', {
							confirmButtonText: '好的'
						});
					}else{
						_this.$message({ message: '重置失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			fansChange(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/virtuals/changeFans", {uid:scope.row.uid, vFans:scope.row.vFans}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.$message({ message: '修改成功', type: 'success', });
					}else{
						_this.$message({ message: '修改失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			handleClose(){
				this.addUserShow = false;
				this.fadanShow = false;
				this.detailShow = false;
			},
			addUser(){
				this.addUserShow = true;
			},
			closeShow(){
				this.detailShow = false;
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Order/deleteOrder", {orid:scope.row.orid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此订单？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/virtuals/getUserList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
		}
	}
</script>

